import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 20px;
  display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
  .line-progress-container {
    padding : 10px 20px;
  }
  .line-progress-title {
    font-size: 18px;
    font-weight: 700;
  }
  .coming-label {
    display: flex;
    justify-content: center;
    align-items: center;

    h1 {
      margin: 0px;
      font-size: clamp(50px, 10vw, 80px); 
    }
  }
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -10px;
  margin-left: -10px;
`;

export const Col = styled.div`
  padding-right: 10px;
  padding-left: 10px;
  flex: ${({ size }) => (size ? `0 0 ${(size / 12) * 100}%` : "0 0 100%")};
  max-width: ${({ size }) => (size ? `${(size / 12) * 100}%` : "100%")};

  @media (max-width: 768px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;
